import styled from 'styled-components'
import { SearchResultsProps } from './search-types'

const SearchResultsWrapper = styled.div<{ isSearchModal }>`
  z-index: 100;
  background-color: #ffffff;
  border-radius: 12px;
  width: 100%;
  margin-top: 8px;

  ${props =>
    !props.isSearchModal &&
    `
    position: absolute;
    border: 1px solid #e7e7f0;
    box-shadow: 0px 2px 10px rgba(4, 2, 34, 0.06);
  `}
`

const SearchResultLink = styled.a<{ isSearchModal }>`
  text-decoration: none;
  color: #040222;
  padding: ${props => (props.isSearchModal ? '16px 0' : '16px')};
  width: 100%;
  display: inline-block;
  cursor: pointer;
  :hover {
    color: #0fa457;
    background-color: #f8f7fc;
  }
  :first-of-type {
    border-radius: 12px 12px 0 0;
  }
`

const SearchAllByBrand = styled.div<{ isMobile }>`
  color: ${props => (props.isMobile ? '#1C73E8' : '#040222')};
  padding: 16px;
  border-radius: 0 0 12px 12px;
  cursor: pointer;
  :hover {
    color: #0fa457;
    background-color: #f8f7fc;
  }
`

const Separator = styled.hr<{ isSearchModal }>`
  margin: ${props => (props.isSearchModal ? '0' : '0 16px')};
  border-top: 1px solid #e0e0e8;
  border-bottom: none;
  border-left: none;
  border-right: none;
`

const NoSearchResult = styled.div`
  color: #040222;
  padding: 24px 16px;
`

const SearchResultLinkWrapper = styled.div<{ isSearchModal }>`
  ${props =>
    props.isSearchModal &&
    `
    padding: 0 16px;
  `}
`

const SearchResults = (props: SearchResultsProps) => {
  const { searchResponse, onShowAllByBrandClick, onSearchResultClick, isMobile, isSearchModal } = props
  const searchResultsExists =
    searchResponse?.success && searchResponse?.success !== 'False' && searchResponse?.data?.length > 0
  const noSearchResults =
    searchResponse?.success && searchResponse?.success !== 'False' && searchResponse.data.length <= 0
  const showAllBrandExists = searchResponse?.show_more_brand_id && searchResponse?.show_more_brand_name

  return (
    <SearchResultsWrapper isSearchModal={isSearchModal}>
      {searchResultsExists && (
        <>
          {searchResponse?.data?.map(result => (
            <SearchResultLinkWrapper isSearchModal={isSearchModal} key={result?.id}>
              <SearchResultLink
                isSearchModal={isSearchModal}
                href={`/cars/${result.slug}/`}
                onClick={() => onSearchResultClick(result)}>
                {result.display_name}
              </SearchResultLink>
              {isSearchModal && <Separator isSearchModal={isSearchModal} />}
            </SearchResultLinkWrapper>
          ))}
          {showAllBrandExists && (
            <>
              {!isSearchModal && <Separator isSearchModal={isSearchModal} />}
              <SearchAllByBrand isMobile={isMobile} onClick={() => onShowAllByBrandClick()} data-testid="showAll">
                {`Show all results for ${searchResponse.show_more_brand_name}`}
              </SearchAllByBrand>
            </>
          )}
        </>
      )}
      {noSearchResults && <NoSearchResult>No match found. Try a different keyword.</NoSearchResult>}
    </SearchResultsWrapper>
  )
}

export default SearchResults
